var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _Basic = require("../../../elements/Basic");

var _MatchComponents = require("./MatchComponents");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Match/AssociatedMatchWithDate.js";

var AssociatedMatchWithDate = function AssociatedMatchWithDate(_ref) {
  var borderX = _ref.borderX,
      mb = _ref.mb,
      textColor = _ref.textColor,
      displayText = _ref.displayText,
      scheduledStartTime = _ref.scheduledStartTime,
      formattedDate = _ref.formattedDate,
      formattedTime = _ref.formattedTime,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["borderX", "mb", "textColor", "displayText", "scheduledStartTime", "formattedDate", "formattedTime"]);
  return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
    borderX: borderX,
    borderColor: "border.main",
    mb: mb,
    position: "relative"
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }), _react.default.createElement(_Basic.View, {
    isFlex: true,
    position: "absolute",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }, _react.default.createElement(_MatchComponents.TeamName, {
    grow: false,
    size: "small",
    color: textColor,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 13
    }
  }, displayText)), _react.default.createElement(_Basic.Row, {
    center: true,
    flexing: true,
    p: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }, scheduledStartTime ? [_react.default.createElement(_Basic.Text, {
    numberOfLines: 1,
    size: "small",
    key: "date-string",
    color: textColor,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 21
    }
  }, formattedDate && formattedTime ? formattedDate + ", " + formattedTime : (0, _moment.default)(scheduledStartTime).format('L') + " - " + (0, _moment.default)(scheduledStartTime).format('LT'))] : _react.default.createElement(_Basic.Text, {
    color: textColor,
    numberOfLines: 1,
    size: "small",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 17
    }
  }, (0, _i18n.default)('no_start_time'))));
};

var _default = (0, _react.memo)(AssociatedMatchWithDate);

exports.default = _default;